export default {
  title: 'Onboarding Wolt Drive',
  subtitle: 'Visibile solo ai responsabili onboarding.',
  steps: {
    request: {
      title: '1. Richiedi la sede a Wolt',
      description:
        'Copia la riga di questo ristorante per il foglio Wolt condiviso. Incollala nella colonna A della prima riga vuota, poi avvisa Wolt nel canale Slack comune.',
    },
    activate: {
      title: '2. Verifica e attiva',
      description:
        "Inserisci l'ID sede che Wolt ha aggiunto al foglio. Viene verificato con un preventivo di prova da Wolt prima che venga salvato.",
    },
  },
  fields: {
    venue_id: {
      label: 'ID sede Wolt',
      placeholder: 'es. 6736f9f5f9e2ab82f9150420',
      invalid: 'Un ID sede Wolt è lungo 24 caratteri e usa solo 0–9 e a–f.',
    },
    priority: {
      label: 'Priorità fornitore',
      options: {
        wolt_primary: 'Wolt principale, mantieni i fornitori attuali come riserva',
        wolt_only: 'Solo Wolt',
      },
    },
  },
  verification: {
    verified: 'Wolt ha confermato questa sede.',
    failed: 'Wolt non ha potuto confermare questa sede.',
    wolt_reason: 'Wolt ha indicato: {{reason}}',
    unavailable_now: 'Wolt non può consegnare da questo venue al momento ({{reason}}). Puoi comunque salvarlo.',
  },
  preview: {
    label: 'Ordine fornitori',
    none: 'nessuno',
  },
  hints: {
    internal_delivery:
      'Questo ristorante consegna con i propri fattorini. Wolt viene usato quando la modalità di consegna sotto è impostata su fattorini esterni.',
    invalid_stored_id:
      "L'ID venue salvato {{venueId}} non è un ID venue Wolt valido, quindi Wolt non viene utilizzato per questo ristorante. Verifica e salva quello corretto.",
  },
  buttons: {
    copy_details: 'Copia dettagli',
    verify: 'Verifica',
    save: 'Salva',
  },
  confirm: {
    title: 'Attivare Wolt Drive?',
    description: "Salva l'ID sede {{venueId}} e modifica l'ordine dei fornitori in: {{providers}}.",
    unsaved_providers: "Le modifiche non salvate all'elenco dei provider qui sotto verranno sostituite.",
    ok: 'Salva',
    cancel: 'Annulla',
  },
  toasts: {
    copied: 'Copiato',
    copy_failed: 'Impossibile copiare i dettagli. Riprova.',
    saved: 'Wolt Drive è configurato per questo ristorante.',
    save_failed: 'Impossibile salvare. Riprova.',
  },
};
